import { leadsServiceApi } from '../../../../../infra/purchasingApi.service';
import { PURCHASING_API } from '../../../../../common/constants/api';

export const getExistingStock = async (model_id) => {
    try {
        const res = await leadsServiceApi({
            method: 'get',
            url: `${PURCHASING_API.BIKE_INVENTORIES}?modelId=${model_id}&limit=100`,
        });

        return {
            result: true,
            options: res.data,
        };
    } catch (e) {
        return {
            msg: e.message,
            error: e,
        };
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/cap_requests/get_existing_stock_request.js